<template>
    <div class="audiopreview">
        <audio ref="player" :src="`${require('../assets/audio/'+ filename)}`">
        </audio>
        <div class="player">
            <div v-if="!playing">
                <div class="previewbtn" @click="onPlayPressed">
                    <span class="previewicon"><i class="fal fa-volume-up"></i></span>
                    <span class="previewlabel">preview</span>
                </div>
            </div>
            <div v-if="playing">
                <div class="playing">
                    <i class="fal fa-volume-up"></i>
                    <span class="stopbtn" @click="onStopPressed"><i class="fal fa-times"></i></span>
                    <div class="progressbar">
                        <div class="progress" :style="'width:'+progress*100+'%'"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "AudioPreview",
        props: {
            filename: String,
            playing: Boolean
        },
        watch: {
            // eslint-disable-next-line no-unused-vars
            playing: function(newVal, oldVal) {
                if (newVal) {
                    this.$refs.player.currentTime = 0;
                    this.$refs.player.play();
                } else {
                    this.$refs.player.pause();
                }
            }
        },
        mounted: function() {
            this.$refs.player.ontimeupdate = () => {
                this.progress = this.$refs.player.currentTime / this.$refs.player.duration;
                if(this.progress >= 1){
                    this.$emit('stop-pressed');
                }
            }
        },
        methods: {
            onPlayPressed: function() {
                this.$emit('play-pressed');
            },
            onStopPressed: function() {
                this.$emit('stop-pressed');
            }
        },
        data() {
            return {
                progress: 0.1
            }
        }
    }
</script>

<style scoped lang="scss">

    .player {
        flex: 0 1 auto;
        align-self: auto;
    }
    .previewbtn{
        //width: 384px;
        height: 48px;
        background: rgba(0, 0, 0, 0.1);

        font-family: Lato;
        font-style: normal;
        font-weight: 300;
        font-size: 16px;
        line-height: 48px;
        letter-spacing: 0.04em;

        color: #BDBDBD;
        transition: color 0.2s;
        padding-left: 20px;
        box-sizing: border-box;

        cursor: pointer;
        white-space: nowrap;

        /* mobile */
        @media only screen and (max-width : 450px)  {
            text-align: center;
            height: 70px;
        }

        .previewicon {
            margin-right: 10px;

            /* mobile */
            @media only screen and (max-width : 450px)  {
                display: block;
                margin-bottom: -25px;
            }

        }
        .previewlabel {
            margin-right: 20px;

            /* mobile */
            @media only screen and (max-width : 450px)  {
                display: block;
            }
        }

        &:hover {
            color: white;
            transition: color 0.2s;
        }

    }
    .playing{
        //width: 384px;
        height: 48px;
        background: rgba(0, 0, 0, 0.1);

        font-family: Lato;
        font-style: normal;
        font-weight: 300;
        font-size: 16px;
        line-height: 48px;
        letter-spacing: 0.04em;

        color: #fff;
        transition: color 0.2s;
        padding-left: 20px;
        box-sizing: border-box;
        position: relative;

        /* mobile */
        @media only screen and (max-width : 450px)  {
            height: 70px;
        }

        .stopbtn {
            position: absolute;
            right: 20px;
            cursor: pointer;

            /* mobile */
            @media only screen and (max-width : 450px)  {
                top:10px;
            }
        }

        .fa-volume-up {

            /* mobile */
            @media only screen and (max-width : 450px) {
                display: none;
            }
        }

        .progressbar {
            width: calc(100% - 2*47px);
            height: 16px;
            background: rgba(0,0,0,0.3);
            position: absolute;
            top:16px;
            left:47px;

            /* mobile */
            @media only screen and (max-width : 450px) {
                width: calc(100% - 67px);
                left:20px;
                top:26px;
            }

            .progress {
                background: rgba(0,0,0,0.3);
                height: 16px;
            }
        }
    }
</style>
